import { getEnv } from "./env";
const { NODE_ENV } = getEnv();
/** Determines the app version from the meta revision tag */
let version;
export default function appVersion() {
  if (version) return version;
  version = "unknown";
  if (NODE_ENV === "production") {
    const revisionTag = document.querySelector("meta[name=revision]");
    if (revisionTag) version = revisionTag.content;
  }
  return version;
}
